import React, { createContext, useContext, useEffect, useState } from 'react';
import { api, setAdminToken, getAdminToken } from '../lib/api';

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = getAdminToken();
        if (!token) { setLoading(false); return; }
        api.get('/auth/me')
            .then((r) => setAdmin(r.data))
            .catch(() => setAdminToken(null))
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const r = await api.post('/auth/login', { email, password });
        setAdminToken(r.data.access_token);
        setAdmin(r.data.admin);
        return r.data;
    };

    const logout = () => {
        setAdminToken(null);
        setAdmin(null);
    };

    return (
        <AdminAuthContext.Provider value={{ admin, loading, login, logout, isAuthed: !!admin }}>
            {children}
        </AdminAuthContext.Provider>
    );
};

export const useAdminAuth = () => {
    const ctx = useContext(AdminAuthContext);
    if (!ctx) throw new Error('useAdminAuth must be used within AdminAuthProvider');
    return ctx;
};
